import Proposals from './Proposals';
export default Proposals;
